import axios, { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { dev } from '@/config/dev.env';
import { prod } from '@/config/prod.env';
import { getStoredToken, useAuthStore } from '@/store/auth';

const NODE_ENV = process.env.NODE_ENV;

const axiosInstance: AxiosInstance = axios.create({
  baseURL: NODE_ENV === 'production' ? prod.BASE_API : dev.BASE_API,
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getStoredToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      const authStore = useAuthStore();
      authStore.clearSession();

      if (window.location.pathname !== '/login') {
        const redirect = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        window.location.assign(`/login?redirect=${encodeURIComponent(redirect)}`);
      }
    } else if (error.response?.status === 403 && window.location.pathname !== '/forbidden') {
      window.location.assign('/forbidden');
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
